import {
  Shield,
  ShieldCheck,
  Ticket,
  TrendingUp,
  Users,
  Mic,
  Wrench,
  Gamepad2,
  Music,
  Coins,
  Gift,
  DoorOpen,
  Bot,
  UserRound,
  Megaphone,
  Sparkles,
} from "lucide-react";

export const FEATURE_CATEGORIES = [
  {
    id: "moderation",
    icon: Shield,
    title: "Moderation",
    description:
      "A complete moderation toolkit — from quick actions to full audit trails, built for fast and fair server management.",
    items: ["Ban", "Kick", "Timeout", "Warn", "Purge", "Logs"],
  },
  {
    id: "security",
    icon: ShieldCheck,
    title: "Security",
    description:
      "Anti-nuke defense, automod, vanity protection, and trusted admin controls — with detailed security logging.",
    items: ["Anti-nuke", "Automod", "Whitelist", "Trusted admins", "Vanity protector", "Security logs"],
  },
  {
    id: "tickets",
    icon: Ticket,
    title: "Tickets",
    description:
      "A full support desk inside Discord — panels, claiming, transcripts, and clean lifecycle management.",
    items: ["Ticket panels", "Claim", "Close", "Reopen", "Delete", "Transcripts", "Logs"],
  },
  {
    id: "leveling",
    icon: TrendingUp,
    title: "Leveling",
    description: "Reward activity with XP, ranks, and role progression that keeps members engaged.",
    items: ["XP", "Levels", "Rank cards", "Level roles"],
  },
  {
    id: "music",
    icon: Music,
    title: "Music",
    description: "High-quality music playback with queue control, right inside your voice channels.",
    items: ["Play", "Queue", "Skip", "Controls"],
  },
  {
    id: "economy",
    icon: Coins,
    title: "Economy",
    description: "A server economy with balances and rewards that give members a reason to stay active.",
    items: ["Balances", "Rewards", "Shop"],
  },
  {
    id: "giveaway",
    icon: Gift,
    title: "Giveaways",
    description: "Run fair, automated giveaways with entry tracking and winner selection.",
    items: ["Create", "Enter", "Reroll"],
  },
  {
    id: "welcome",
    icon: DoorOpen,
    title: "Welcome & Autorole",
    description: "Greet new members and assign roles automatically the moment they join.",
    items: ["Welcome messages", "Autorole", "Auto react", "Auto responder"],
  },
  {
    id: "voice",
    icon: Mic,
    title: "Voice",
    description: "Dynamic voice channels with VoiceMaster, Join to Create, member controls, and voice moderation.",
    items: ["Join to Create", "VoiceMaster", "VC controls", "VC moderation"],
  },
  {
    id: "social",
    icon: Users,
    title: "Social",
    description: "Community features that make your server feel alive — from AFK states to birthdays.",
    items: ["AFK", "Birthday", "Auto responses", "Reaction roles"],
  },
  {
    id: "profile",
    icon: UserRound,
    title: "Profiles",
    description: "Member profiles, custom roles, role icons, and nameplate cosmetics for personal flair.",
    items: ["Profiles", "Custom roles", "Role icons", "Nameplates"],
  },
  {
    id: "utility",
    icon: Wrench,
    title: "Utility",
    description: "Everyday tools for information, lookup, embeds, and server management — right where you need them.",
    items: ["Server info", "User info", "Avatar", "Banner", "Embed builder", "Snipe"],
  },
  {
    id: "notifications",
    icon: Megaphone,
    title: "Notifications",
    description: "Stay on top of community activity with built-in alerts and statistics tracking.",
    items: ["YouTube alerts", "Statistics"],
  },
  {
    id: "automation",
    icon: Bot,
    title: "Automation",
    description: "Auto responders, auto reactions, and prefix controls that put routine work on autopilot.",
    items: ["Auto responder", "Auto react", "Prefix controls"],
  },
  {
    id: "fun",
    icon: Gamepad2,
    title: "Fun",
    description: "Interactive commands and games to keep your community entertained.",
    items: ["Truth or Dare", "Games", "Interactive commands", "Steal"],
  },
  {
    id: "premium-module",
    icon: Sparkles,
    title: "Premium",
    description: "Exclusive premium commands and enhanced limits for upgraded servers.",
    items: ["Premium commands", "Enhanced limits"],
  },
];
